module.exports = __webpack_public_path__ + "static/media/icon_gx.e8fdebac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/icon_gx.svg
// module id = 579
// module chunks = 0